import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Card,
  CardBody,
  Progress,
  Button,
  Row,
  Col,
  Modal,
  ModalBody,
} from 'reactstrap';
import LessonNavBar from "components/Navbars/LessonNavBar.js";
import { FaArrowLeft, FaArrowRight, FaRedo, FaCheck } from 'react-icons/fa';
import QuizComponent from "components/Quiz/QuizComponent.js";
import NavigationButton from "components/NavigationButton/NavigationButton.js";


const JS_M1_Q1Component = () => {
  const lessonID = "JSQ1";
  const mainRef = useRef(null);

  const [quizCompletedFlag, setQuizCompletedFlag] = useState(false);
  const completedLessons = [
    "What Is JavaScript?",
    "Where Does JavaScript Run?",
    "How to Write and Run JavaScript",
    "Comments in JavaScript",
    "Basic Syntax of JavaScript",
    "Indentation",
    "Naming Conventions",
    "Semicolons",
  ];


  return (
    <>
      <div className=" lessonMain p-0 m-0" style={{ minHeight: "100vh" }}>
        <LessonNavBar />
        <main id="main" tabIndex={-1} className="lessonMain flex-grow-1">
          <section >
            <QuizComponent lessonID={lessonID} completedLessonList={completedLessons} setQuizCompletedFlag={setQuizCompletedFlag} questionsCount={10}/>
          </section>
          <section className=" lessonFooterHeight lessonBackgroundColor1" >
            <Container className="container-lg "  >
              <Row className=" p-3   align-items-center  justify-content-between">
                <NavigationButton direction="back" page="JS_M1_L5_3" ></NavigationButton>
                {quizCompletedFlag == true && (
                  <NavigationButton direction="next" page="JS_M2_L1" ></NavigationButton>
                )}
              </Row>
            </Container>
          </section>
        </main>
      </div>
    </>
  );
}


export default JS_M1_Q1Component;